import { render, staticRenderFns } from "./VisrTermsForm.vue?vue&type=template&id=6e65b4e5"
import script from "./VisrTermsForm.ts?vue&type=script&lang=ts&external"
export * from "./VisrTermsForm.ts?vue&type=script&lang=ts&external"
import style0 from "./VisrTermsForm.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports